module.exports = "https://static.wmbcdn.com/uniweb/images/6f2d7cc967549969cf8f58ed9afc3daa.svg";